// Copyright (c) 2025 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { api } from '@/api/axios-instance';
import { parseResponse } from '@/api/parse-response';
import { SuccessResponse, successResponseSchema } from '@/api/schemas';

/**
 * Deletes a time record by its key.
 *
 * @param recordKey - The key of the time record to delete
 */
export async function deleteTimeRecord(
  recordKey: string
): Promise<SuccessResponse> {
  const url = `/v1/time-record/${recordKey}`;
  const response = await api.delete(url);

  return parseResponse(successResponseSchema, response.data, {
    schemaName: 'DeleteTimeRecord',
    endpoint: url,
  });
}
